import React from "react";

const NotFound = () => {
  return (
    <div className="container mx-auto px-10 text-center my-20">
      <h2 className="font-bold text-3xl text-neutral-600">Page Not Found!!</h2>
      <p className="font-light text-8xl text-neutral-600">404</p>
    </div>
  );
};

export default NotFound;
